import React from "react";

import { Chip, formatNumber } from "@narmi/design_system";
import { format, parseISO } from "date-fns";

import { formatDelta } from "../../format";

import styles from "./MatchedReceiptDrawer.module.scss";

import type { SuggestedMatch } from "../../hooks/useReceiptsList";

interface MatchedTransactionCardProps {
  match: SuggestedMatch;
}

const parseAmount = (raw: string | null): number | null => {
  if (raw === null) return null;
  const value = Number(raw);
  return Number.isFinite(value) ? value : null;
};

const formatAmount = (raw: string | null): string => {
  const value = parseAmount(raw);
  if (value === null) return "";
  return formatNumber(value, "currency");
};

const formatLongDate = (raw: string | null): string => {
  if (!raw) return "";
  try {
    return format(parseISO(raw), "MMM d, yyyy");
  } catch {
    return raw;
  }
};

const MatchedTransactionCard = ({ match }: MatchedTransactionCardProps) => {
  const delta = formatDelta(match.delta);
  const dateLabel = formatLongDate(match.date);

  return (
    <div
      className="border--all rounded--all--m padding--all--m bgColor--white"
      data-testid="matched-transaction-card"
    >
      <div className={styles["matched-card-row"]}>
        <span className="fontColor--primary fontWeight--semibold">
          {match.description ?? ""}
        </span>
        <div className={styles["matched-card-amount"]}>
          <span className="fontColor--primary fontWeight--semibold">
            {formatAmount(match.amount)}
          </span>
          {delta && <Chip kind={delta.kind} label={delta.display} />}
        </div>
      </div>
      {dateLabel && (
        <div className="margin--top--xs fontColor--secondary fontSize--s">
          {dateLabel}
        </div>
      )}
    </div>
  );
};

export default MatchedTransactionCard;
